module.exports = __webpack_public_path__ + "img/Small-Horizontal-Rectangular-Attachment-27.535eb8d0.png";